<template>
<div class="tw-text-sm font-normal">
  <a v-if="storeAnswer.upload_file_name" class="tw-link" :href="`/uploads/${ storeAnswer.id }`" target="_blank">
    {{ storeAnswer.upload_file_name }}
  </a>
</div>
</template>
<script>
import mixin from './_mixin_display'
export default {
  mixins: [mixin],
  props: {
    value: {},
    index: {},
  },
  skipBasic: true,
}
</script>